import { render } from "./LogDetail.vue?vue&type=template&id=ff4696d8&scoped=true"
import script from "./LogDetail.vue?vue&type=script&lang=js"
export * from "./LogDetail.vue?vue&type=script&lang=js"

import "./LogDetail.vue?vue&type=style&index=0&id=ff4696d8&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff4696d8"]])

export default __exports__